import React from 'react';
import { getPracticeList } from 'api/group';
import { TPractice } from 'types/group';
import { isOpPortal } from 'utils/common';

let globalList: TPractice[] | undefined;
let globalPromise: Promise<void> | null = null;
const globalListeners: Set<() => void> = new Set();

const notifyListeners = () => {
    globalListeners.forEach((fn) => fn());
};

const fetchPracticeList = async () => {
    try {
        const result = await getPracticeList();
        if (!result.error) {
            globalList = result?.data?.data;
        }
    } catch (e) {
        console.error(e);
    }
    globalPromise = null;
    notifyListeners();
};

const ensureFetched = () => {
    if (globalList) return;
    if (!globalPromise) {
        globalPromise = fetchPracticeList();
    }
};

const useSupportPracticeList = (): [TPractice[] | undefined, boolean, () => void] => {
    const [, forceUpdate] = React.useReducer((x: number) => x + 1, 0);
    const loading = !!globalPromise;

    React.useEffect(() => {
        if (isOpPortal()) {
            return;
        }
        globalListeners.add(forceUpdate);
        ensureFetched();
        return () => {
            globalListeners.delete(forceUpdate);
        };
    }, []);

    const refetch = React.useCallback(() => {
        if (isOpPortal()) {
            return;
        }
        globalPromise = fetchPracticeList();
        notifyListeners();
    }, []);

    return [globalList, loading, refetch];
};

export default useSupportPracticeList;
